import React from 'react'
import { observer } from "mobx-react-lite"
// import { Redirect, useMatch, useNavigate } from "@reach/router"
import classes from './PayPlan.module.scss'
// import {
//   PayPalScriptProvider,
//   PayPalHostedFieldsProvider,
//   PayPalHostedField,
//   PayPalButtons
// } from "@paypal/react-paypal-js";


const PayPlan = observer(() => {

  return <div className={classes.root}>
    {/* <PayPalScriptProvider options={{ "client-id": "AVqwojW1GGHjowKKF6l2U_bdQU9zinE5oQpCL1AvNjB_0HD3WElTOWxQEkH3efkSautNXI8W72dzKMIR", vault: true, intent: 'subscription' }}>
       <PayPalButtons
        createSubscription={(data , actions ) =>
            actions.subscription.create({
                plan_id: 'P-0K783942EE888791VMFSV6GQ',
            })
        }
        style={{
            label: "subscribe",
        }}
    />
    </PayPalScriptProvider> */}
  </div>
})

export default PayPlan;